import { usePromotionMeRetrieve } from '@/api/gen'
import { useAuth } from '@/hooks/use-auth'

export const useUserPromoStatus = () => {
  const { isAuthorized } = useAuth()
  const { data, isFetching } = usePromotionMeRetrieve({
    query: {
      enabled: isAuthorized,
    },
  })

  return {
    userRake: data?.rake_race.score,
    flipOut1: data?.all_in_flipout_1 ?? null,
    flipOut2: data?.all_in_flipout_2 ?? null,
    tickets: data?.free_tickets ?? null,
    loading: isFetching,
  }
}
